import React, { FC, useCallback, useEffect } from "react";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import {
  Box,
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Avatar,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { GTAScreenType, SCREEN_TYPE } from "../../../utils/constants";
import TriggerGTAEvent from "../../../utils/GTA";
import { useAppTranslation } from "../../../hooks/useAppTranslation";
import { T_menu } from "../GeneralAppElements_Types";

interface Props {
  handleBackBtnClick: Function;
  setVisibleComponent: Function;
  pathname?: string;
}

const AppSettings: FC<Props> = ({
  handleBackBtnClick,
  pathname,
  setVisibleComponent,
}) => {
  const { t } = useAppTranslation("common");
  const handleListItemClick = useCallback((item: T_menu) => {
    triggerCleverTapEvent("serv_app_settings_option_select", {
      ScreenType: SCREEN_TYPE.DashboardScreenType,
      isPrevPageNameRequired: true,
      ScreenName: "Servicing App Settings Option Selection Screen",
      ctaText: item.menuDisplayName,
    });
    TriggerGTAEvent("serv_app_settings_option_select", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_app_settings_option_selection_screen",
      CTA_text: item.menuDisplayName,
    });
    if (item.pathName) {
      setVisibleComponent(item.pathName);
    }
  }, []);

  const profileHamburgerMenuData = useAppSelector(
    (state) => state.GeneralAppElementsSlice.quickActionMenu,
  );
  const settingSubMenu = profileHamburgerMenuData?.[111]?.find(
    (i) => i.pathName === "app-settings",
  )?.menuDetails;

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaAppSettingOptSelection.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  }, []);

  return (
    <CommonMenuListPage
      title={t("appSettings.titles.appSettings")}
      handleBackBtnClick={handleBackBtnClick}
      pathname={pathname}
    >
      <Box>
        {settingSubMenu ? (
          settingSubMenu
            .filter((item) => item.menuId)
            .map((item) => (
              <React.Fragment key={item.menuDisplayName}>
                <ListItem
                  key={item.menuId}
                  onClick={() => handleListItemClick(item)}
                  secondaryAction={
                    <IconButton
                      sx={{ marginRight: 0 }}
                      edge="end"
                      aria-label="delete"
                    >
                      <KeyboardArrowRightIcon />
                    </IconButton>
                  }
                  sx={{
                    marginY: ".625rem",
                    paddingLeft: "1.5rem",
                  }}
                >
                  <ListItemAvatar>
                    <Avatar src={item.menuIcon} />
                    {/* <item.preIcon fontSize="large" sx={{ color: Colors.red }} /> */}
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="h5" marginBottom={".3125rem"}>
                        {item.jsonKey ? t(item.jsonKey) : item.menuDisplayName}
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))
        ) : (
          <></>
        )}
      </Box>
    </CommonMenuListPage>
  );
};

export default AppSettings;
